export enum EnAuthOptionsOperator {
  OR = '||',
  AND = '&&'
}
